<script>
import BaseView from "@/mixins/BaseView.vue";
import OmniTable from "@/components/omni/OmniTable.vue";
import PageHeader from "@/components/header/PageHeader.vue";
import FacilitiesSearchForm from "@/views/companies/facilities/view/components/FacilitiesSearchForm.vue";
import { mapState } from "pinia";
import { useAppStore } from "@/store/app.store.ts";
import FacilityInfo from "@/views/trips/components/FacilityInfo.vue";
import CreateNewCompanyButton from "@/components/buttons/CreateNewCompanyButton.vue";
import EditCompanyButton from "@/components/buttons/EditCompanyButton.vue";

export default {
  name: "FacilitiesPage",
  components: {
    EditCompanyButton,
    CreateNewCompanyButton,
    FacilityInfo,
    FacilitiesSearchForm,
    PageHeader,
    OmniTable,
  },
  mixins: [BaseView],
  data() {
    return {
      perm: "facilities",
      headers: [
        { title: "Name", key: "name" },
        {
          title: "Type",
          key: "type",
          value: (item) => item.type.charAt(0).toUpperCase() + item.type.slice(1),
        },
        { title: "Location", key: "address" },
        {
          title: "",
          key: "actions",
          align: "end",
          width: 58,
          sortable: false,
        },
      ],
      filter: { search: "" },
      data: { items: [] },
      loading: false,
    };
  },
  computed: {
    ...mapState(useAppStore, ["mobile"]),
  },
  async created() {
    this.setTitle(this.$t("company.facilities"));
    await this.refresh();
  },
  methods: {
    async refresh() {
      this.loading = true;
      const filter = { ...this.filter, ...this.params };

      try {
        const resp = await this.$api.company.findFacilities(filter);
        this.data = resp.data;
      } catch (e) {
        console.error("Error load facilities list: ", e);
      }

      this.loading = false;
    },
    async search(params) {
      this.params.page = 1;
      this.filter = params;

      await this.refresh();
    },
  },
};
</script>

<template>
  <v-container :fluid="true" class="pt-6 pb-10 pl-6 pr-6 height-100">
    <page-header :header="$t('company.facilities')">
      <template #suffix>
        <create-new-company-button :to="{ name: 'facilities-create' }" />
      </template>
    </page-header>
    <facilities-search-form @search="search" />

    <omni-table
      :footer-props="{ 'items-per-page-options': pagination.itemsPerPage }"
      :headers="headers"
      :items="data.items"
      :items-length="data.total || 0"
      :items-per-page="params.pageSize"
      :loading="loading"
      :mobile-breakpoint="0"
      :page="params.page"
      :show-all-option="false"
      @update:page="updatePage"
      @update:items-per-page="updatePageSize"
    >
      <template #[`item.address`]="{ item }">
        <facility-info :facility="item" address-class="text-grey-darken-3" class="text-black" hide-name />
      </template>
      <template #[`item.actions`]="{ item }">
        <edit-company-button :id="item.id" :to="{ name: 'facilities-edit', params: { id: item.id } }" />
      </template>
    </omni-table>
  </v-container>
</template>
